<!-- Filter Bar -->
<div class="d-flex flex-wrap gap-16 m-b-16 align-items-center">
  <mat-form-field appearance="outline" class="filter-field hide-hint">
    <mat-label>{{ 'LABEL.SEARCH_LABEL' | translate }}</mat-label>
    <input matInput [(ngModel)]="searchText" (ngModelChange)="onSearchChange($event)" placeholder="Patient name">
    <mat-icon matSuffix>
      <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
    </mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="filter-field hide-hint">
    <mat-label>{{ 'ENTITY.WARD' | translate }}</mat-label>
    <mat-select [(ngModel)]="wardFilter" (selectionChange)="onFilterChange()">
      <mat-option [value]="null">All</mat-option>
      @for (ward of wardsList; track ward.id) {
      <mat-option [value]="ward.id">{{ ward.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="filter-field hide-hint">
    <mat-label>{{ 'LABEL.DOCTOR' | translate }}</mat-label>
    <mat-select [(ngModel)]="doctorFilter" (selectionChange)="onFilterChange()">
      <mat-option [value]="null">All</mat-option>
      @for (doctor of doctorsList; track doctor.id) {
      <mat-option [value]="doctor.id">{{ doctor.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button mat-stroked-button (click)="clearFilters()">
    {{ 'BUTTON.BTN_CLEAR' | translate }}
  </button>
</div>

<!-- Table -->
<mat-card class="cardWithShadow">
  <mat-card-content>
    @if (isLoading) {
    <div class="d-flex justify-content-center p-24">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
    } @else {
    <div class="table-scroll-area">
      <table mat-table [dataSource]="dataSource" class="w-100">
        <ng-container matColumnDef="ipdNumber">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'LABEL.IPD_NO' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="f-s-14">{{ row.ipdNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="patientName">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'LABEL.PATIENT_NAME' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="f-s-14">
            <span class="f-w-600">{{ row.patientName }}</span>
            <br>
            <span class="f-s-12 mat-body-1">{{ row.patientNumber }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="wardRoom">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'ENTITY.WARD' | translate }} / {{ 'ENTITY.ROOM' | translate }} / {{
            'ENTITY.BED' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="f-s-14">{{ row.wardName }} / {{ row.roomNo }} / {{ row.bedNo }}</td>
        </ng-container>

        <ng-container matColumnDef="doctor">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'LABEL.DOCTOR' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="f-s-14">{{ row.doctorName }}</td>
        </ng-container>

        <ng-container matColumnDef="admissionDate">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'LABEL.ADMISSION_DATE' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="f-s-14">{{ row.admissionDate | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="days">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'LABEL.DAYS_ADMITTED' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="f-s-14">
            <span class="f-w-600">{{ row.daysAdmitted }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="diagnosis">
          <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'LABEL.DIAGNOSIS' | translate }}</th>
          <td mat-cell *matCellDef="let row" class="f-s-14">{{ row.provisionalDiagnosis || '-' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="cursor-pointer" (click)="viewPatient(row)">
        </tr>
      </table>

      @if (dataSource.data.length === 0) {
      <div class="p-24">
        <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
      </div>
      }
    </div>
    }
  </mat-card-content>
</mat-card>